import { createGlobalStyle } from 'styled-components'
import 'typeface-space-mono'

export default createGlobalStyle`
  /*
   * Metric-matched fallback for Space Mono. While the real font is still
   * downloading, text is shown in Courier New scaled/overridden to occupy the
   * exact same vertical and horizontal space as Space Mono, so when Space Mono
   * swaps in there is no reflow (no first-load downward shift). Values derived
   * from Space Mono's own metrics (upm 1000, ascent 1120, descent -361,
   * avg width 612) against Courier New (upm 2048, avg width 1229).
   */
  @font-face {
    font-family: 'Space Mono Fallback';
    src: local('Courier New'), local('CourierNewPSMT');
    size-adjust: 101.98%;
    ascent-override: 109.82%;
    descent-override: 35.40%;
    line-gap-override: 0%;
  }

  html {
    padding: 0;
    margin: 0;
    background-color:${(props) => props.theme.background};
  }

  ::selection {
      background-color:${(props) => props.theme.highlight};
      color: ${(props) => props.theme.background};
    }

  body {
    margin: 0;
    padding: 0
    background-color: ${(props) => props.theme.background};
    color: ${(props) => props.theme.main};
    font-family: 'Space Mono', 'Space Mono Fallback', 'Courier New', Courier,
      monospace;
    font-size: 16px;
  }

  h1 {
    font-size: 35px;
    line-height: 40px;
  }
  h2 {
    font-size: 22px;
    line-height: 28px;
    margin-top: 40px;
  }
  h3 {
    font-size: 18px;
    line-height: 22px;
  }

  ol {
    display: block;
    margin-bottom: 10px;
  }
`
